<template>
  <div class="infoBox">
    <a-row>
      <a-col
        :xs="24"
        :sm="24"
        :md="11"
        :lg="8"
        :xl="8"
        v-for="item in infoData"
        :key="item.key"
        class="_col"
      >
        <span class="key">{{ item.key }}:</span>
        <span class="value">{{ item.value }}</span>
      </a-col>
      <slot></slot>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'CustomizeFormInfo',
  data() {
    return {}
  },
  props: {
    infoData: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="less">
._col {
  margin-bottom: 12px;
}
.key {
  font-size: 14px;
  margin-right: 12px;
}
.value {
  font-size: 14px;
}
.infoBox {
  width: 100%;
}
</style>
